import { flatpickrOptions } from "../flatpickrOptions";

function initSospeso() {
    const container = $('form.journal_entry .sospeso');
    if (container.length > 0) {


        // VISUALIZZA LA SEZIONE RELATIVA AL SOSPESO
        const $select = container.closest('form').find("#journal_entry_document_type_id");
        const $documentKindSelect = $('form.journal_entry #journal_entry_document_kind_id')
        const $parentSelect = $('form.journal_entry #journal_entry_parent_id');
        const $dataDocument = $('form.journal_entry #journal_entry_data_documento')
        const $rifDocument = $('form.journal_entry #journal_entry_riferimento_documento')
        $select.on('change', function (select) {
            const option = $select.find("option:selected");
            if (option.length > 0 && option.data('identifier') == container.data("identifier")) {

                container.closest('.inputs').removeClass('columns2').addClass('columns3')
                container.fadeIn(500, function () {
                    container.show();
                });

            } else {
                container.fadeOut(500, function () {
                    container.hide();
                    container.closest('.inputs').removeClass('columns3').addClass('columns2')
                });
            }
        })


        // CLONA I VALORI PER DATA DOCUMENTP, RIFERIMENTO FATTURA E NATURA
        $parentSelect.on('change', function (select) {
            const option = $parentSelect.find("option:selected");
            const $a = $dataDocument.closest('.date_picker').find('.flatpickr:hidden');
            const fp = flatpickr($a, flatpickrOptions);
            if ($parentSelect.val()) {
                $documentKindSelect.val(option.data('document-kind-id'))
                $documentKindSelect.trigger('change')


                fp && fp.setDate(option.attr('data-document-date'), true)
                fp._input && fp._input.setAttribute("disabled", "disabled");

                $rifDocument.val(option.data('riferimento-documento'))
                $rifDocument.attr("readonly", true)
                // container.show();
            } else {
                $documentKindSelect.val("")
                $documentKindSelect.trigger('change')
                fp && fp.clear()
                fp._input && fp._input.removeAttribute("disabled");

                $rifDocument.val('')
                $rifDocument.removeAttr("readonly")
            }


        })
        $select.trigger('change');
    }
}

function refreshParentSospeso(value) {
    // aggiorna la lista dei sospesi in base alla controparte
    const $counterpartSelect = $('form.journal_entry #journal_entry_counterpart_id')
    const $suspendedSelect = $('form.journal_entry #journal_entry_parent_id')
    const $udpSelect = $('form.journal_entry #journal_entry_udp_id')
    const $currentSuspendedValueAlreadySelected = $suspendedSelect.data('current-parent-id-selected')
    $.getJSON(`/admin/journal_entries/parents?document_type_id=${value}&counterpart_id=${$counterpartSelect.find('option:selected')?.val()}&parent_id=${$currentSuspendedValueAlreadySelected}&udp_id=${$udpSelect.val()}`, function (data) {
        const autoSelect = data.length === 1
        const alreadySelected = parseInt($suspendedSelect.find('option:selected')?.val());
        $suspendedSelect.find('option').remove()
        const newOption = new Option(" ", '', false, false);
        !autoSelect && $suspendedSelect.append(newOption);
        autoSelect && $suspendedSelect.trigger('change')
        $.each(data, function (i, d) {
            const newOption = new Option(d[0], d[1], false, autoSelect || (alreadySelected === d[1]));
            if (d[2]) {
                for (const [key, value] of Object.entries(d[2])) {
                    newOption.setAttribute(key, value)
                }
            }
            $suspendedSelect.append(newOption);
        })
        $suspendedSelect.val() && $suspendedSelect.trigger('change');
    });
}

export { initSospeso, refreshParentSospeso }